/**
 * @generated SignedSource<<d63c34d3dfec384c3307ff0e89f52d2d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ElementTypeV2 = "clozeText" | "file" | "multipleChoice" | "order" | "podcast" | "randomMultipleChoice" | "text" | "video" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PaediaContentElement_ContentSubmissionFragment$data = {
  readonly definition: {
    readonly currentElementState?: {
      readonly element: {
        readonly elementType: ElementTypeV2;
      };
    } | null;
  };
  readonly " $fragmentSpreads": FragmentRefs<"FileElementPart_ContentSubmissionFragment" | "PaediaMultipleChoiceElementPart_ContentSubmissionFragment" | "PodcastElementPart_ContentSubmissionFragment" | "TextElementPart_ContentSubmissionFragment" | "VideoElementPart_ContentSubmissionFragment">;
  readonly " $fragmentType": "PaediaContentElement_ContentSubmissionFragment";
};
export type PaediaContentElement_ContentSubmissionFragment$key = {
  readonly " $data"?: PaediaContentElement_ContentSubmissionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaediaContentElement_ContentSubmissionFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaediaContentElement_ContentSubmissionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "definition",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "currentElementState",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "element",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "elementType",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "ActiveELearningContentSubmissionDefinition",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FileElementPart_ContentSubmissionFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaediaMultipleChoiceElementPart_ContentSubmissionFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PodcastElementPart_ContentSubmissionFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TextElementPart_ContentSubmissionFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "VideoElementPart_ContentSubmissionFragment"
    }
  ],
  "type": "ContentSubmission",
  "abstractKey": null
};

(node as any).hash = "66f3f03b282d829a84b3981cdcbfc5f4";

export default node;
